<script>
  export let forType = 'video';
</script>

<div class="flex flex-col items-center justify-between gap-4 bg-white p-10">
  <div class="flex w-full flex-grow gap-4 p-4">
    <!-- For Image -->
    <div class="w-1/3">
      {#if forType === 'video'}
        <img src="https://storage.googleapis.com/sermonshots-local-storage/public/img3a2.png" alt="" />
      {:else if forType === 'template'}
        <img src="https://storage.googleapis.com/sermonshots-local-storage/public/img3b2.png" alt="" />
      {:else if forType === 'transcript'}
        <img
          src="https://storage.googleapis.com/sermonshots-local-storage/public/img5f%20download%20transcript.png"
          alt=""
        />
      {/if}
    </div>
    <!-- For Content -->
    <div class="w-2/3">
      <!-- For Header -->
      <h1 class="mb-2 text-xl font-bold text-gray-900">
        {#if forType === 'video'}
          Want to add more videos?
        {:else if forType === 'template'}
          Access 1000+ templates now!
        {:else if forType === 'transcript'}
          Want to download this script?
        {:else if forType === 'download'}
          Your sermon clip is ready!
        {:else if forType === 'editor'}
          Enjoying Sermon Shots?
        {/if}
      </h1>
      <!-- For Message -->
      <p class="text-sm text-gray-700">
        {#if forType === 'video' || forType === 'template' || forType === 'transcript'}
          Enjoying what Sermon Shots offers? Elevate your experience by upgrading.
        {:else if forType === 'download'}
          Enjoying what Sermon Shots offers? Elevate your experience by upgrading or go ahead and download this sermon
          clip.
        {:else if forType === 'editor'}
          Upgrade to Gold to edit more sermon clips for your church.
        {/if}
      </p>
      <!-- For Action Buttons -->
      <div class="mt-4 flex space-x-4">
        <a href="/pricing" class="rounded-lg bg-gradient-to-r from-primary to-secondary p-4 text-sm text-white">
          Upgrade
        </a>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
</style>
